/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { valorAPesos } from "utils/formatters";
import { makeNiceText } from "utils/formatters";

const getRows = (data, ejecutarAccion) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        nombre: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="caption">
              {item?.producto?.nombre ? makeNiceText(item?.producto?.nombre) : "Sin nombre"}
            </SoftTypography>
          </SoftBox>
        ),
        cantidad: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="caption">
              {item?.cantidad || ""}
            </SoftTypography>
          </SoftBox>
        ),
        comentario: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="caption">
              {item?.comentario || ""}
            </SoftTypography>
          </SoftBox>
        ),
        ingredientesQuitados: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="caption" fontWeight="medium">
              {item?.ingredientesQuitados
                ? item.ingredientesQuitados?.map((ingrediente) => {
                    return "Sin " + ingrediente.nombre + " - ";
                  })
                : "-"}
            </SoftTypography>
          </SoftBox>
        ),
        precio: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="caption">
              {item?.precio ? valorAPesos(item.precio) : ""}
            </SoftTypography>
          </SoftBox>
        ),
        numeroComanda: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="caption">
              {item?.numeroComanda ? item.numeroComanda : ""}
            </SoftTypography>
          </SoftBox>
        ),
        // estado: (
        //   <SoftBox>
        //     <SoftTypography verticalAlign="text-top" variant="caption" fontWeight="bold">
        //       {item?.estado ? makeNiceText(item?.estado) : ""}
        //     </SoftTypography>
        //   </SoftBox>
        // ),
        accion: (
          <SoftBox
            mr={2}
            display="flex"
            flexDirection="row"
            justifyContent="flex-end"
            sx={{
              gap: 1,
            }}
          >
            {item.estado === "PENDIENTE" && (
              <Tooltip title="Marcar como listo" placement="top">
                <Icon
                  fontSize="small"
                  sx={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    ejecutarAccion("listo", item);
                  }}
                >
                  done
                </Icon>
              </Tooltip>
            )}
            {item.estado !== "CANCELADO" && (
              <Tooltip title="Borrar" placement="top">
                <Icon
                  fontSize="small"
                  sx={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    ejecutarAccion("borrar", item);
                  }}
                >
                  cancel
                </Icon>
              </Tooltip>
            )}
          </SoftBox>
        ),
        color: item?.estado === "PENDIENTE" ? "#fadbd8" : "transparent",
      });
    });
  }

  return rows;
};

const columns = [
  // {
  //   name: "numeroComanda",
  //   desc: "Comanda",
  //   align: "center",
  //   width: "1%",
  //   noOrder: true,
  // },
  { name: "nombre", desc: "Nombre", align: "left", noOrder: true },
  { name: "cantidad", desc: "Cantidad", align: "center", noOrder: true },
  { name: "comentario", desc: "Comentario", align: "left", noOrder: true },
  // { name: "ingredientesQuitados", desc: "Ingredientes Quitados", align: "left", noOrder: true },
  // { name: "estado", desc: "Estado", align: "left", noOrder: true },
  { name: "precio", desc: "Precio", align: "center", noOrder: true },
  { name: "accion", desc: " ", align: "center", width: "1%", noOrder: true },
];

export default { columns, getRows };
